<script setup lang="ts">
  import { computed, useSlots } from 'vue';
  import type { FlipDirection } from '../composables/useFlipRouter';

  interface FlipRouterViewProps {
    direction?: FlipDirection;
  }

  const props = withDefaults(defineProps<FlipRouterViewProps>(), {
    direction: 'forward',
  });

  const transitionName = computed<string>(() => `flip-${props.direction}`);

  const slots = useSlots();
  const slotNames = computed<string[]>(() => Object.keys(slots));
</script>

<template>
  <div
    class="flip-router-view"
    data-testid="flip-router-view"
  >
    <transition :name="transitionName">
      <router-view>
        <template
          v-for="name in slotNames"
          #[name]="slotProps"
        >
          <slot
            :name="name"
            v-bind="slotProps || {}"
          />
        </template>
      </router-view>
    </transition>
  </div>
</template>

<style scoped lang="scss">
  .flip-router-view {
    box-sizing: border-box;
    overflow-x: clip;
    position: relative;
    width: 100%;
  }

  .flip-forward-enter-active,
  .flip-forward-leave-active,
  .flip-back-enter-active,
  .flip-back-leave-active {
    pointer-events: none;
    transition: transform 0.3s ease;
    will-change: transform;
  }

  .flip-forward-enter {
    transform: translateX(100%);
  }

  .flip-forward-leave-to {
    transform: translateX(-100%);
  }

  .flip-back-enter {
    transform: translateX(-100%);
  }

  .flip-back-leave-to {
    transform: translateX(100%);
  }
</style>
